<template>
	<div class="agentlist">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">代理管理</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">搜索代理商</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="width: 350px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">ID</span>
								<a-input placeholder="请输入ID" style="width: 260px" v-model="searchlist.agency_id" />
							</div>
							<div style="width: 350px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">微信昵称</span>
								<a-input placeholder="请输入微信昵称" style="width: 260px" v-model="searchlist.nick_name" />
							</div>
							<div style="width: 350px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">手机号码</span>
								<a-input placeholder="请输入手机号码" style="width: 260px" v-model="searchlist.phone_number" />
							</div>
							<div style="text-align: center;margin-top: 20px;">
								<a-button type="primary" size="small" style="width: 96px;font-size: 12px;" @click="searchbtn">搜索</a-button>
							</div>
						</div>
						<div v-if="userlist" style="margin-top: 20px;">
							<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
								<a-col :span="2" style="text-align: center;">微信昵称</a-col>
								<a-col :span="2" style="text-align: center;">微信头像</a-col>
								<a-col :span="3" style="text-align: center;">手机号码</a-col>
								<a-col :span="2" style="text-align: center;">平台来源</a-col>
								<a-col :span="2" style="text-align: center;">来源app</a-col>
								<a-col :span="4" style="text-align: center;">等级设置</a-col>
								<a-col :span="4" style="text-align: center;">操作</a-col>
							</a-row>
							<div style="color: #666;font-size: 14px;" v-for="user in userlist" :key="user">
								<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
									<a-col :span="2" style="text-align: center;">{{user.nick_name}}</a-col>
									<a-col :span="2" style="text-align: center;"><img :src="user.avatar_url" height="56" /></a-col>
									<a-col :span="3" style="text-align: center;">{{user.phone_number}}</a-col>
									<a-col :span="2" style="text-align: center;">{{platform_name[user.user_from_platform]}}</a-col>
									<a-col :span="2" style="text-align: center;">{{app_name[user.user_from_app]}}</a-col>
									<a-col :span="4" style="text-align: center;">
										<a-select v-model="user.level" placeholder="请选择" style="min-width: 100px;">
											<a-select-option value="1">皇冠会员</a-select-option>
											<a-select-option value="2">钻石会员</a-select-option>
										</a-select>
									</a-col>
									<a-col :span="4" style="text-align: center;">
										<div>
											<a-button size="small" type="primary" :disabled="!user.level" ghost style="width: 96px;font-size: 12px;"
											 @click="addagent(user)">加入代理</a-button>
										</div>
									</a-col>
								</a-row>
							</div>
						</div>
					</div>
					<div class="card-container">
						<a-tabs :defaultActiveKey="liststatus" :activeKey="liststatus" type="card" :tabBarGutter="5" @change="(activeKey)=>{this.startpage=0;this.endpage=10;this.pageSize=10;this.liststatus=activeKey;this.$router.push({
					name: 'agentlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				});this.initialize();}">
							<a-tab-pane tab="皇冠会员" :key="1">
								<div style="padding-bottom: 50px;">
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!agentlist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="agentlist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="2" style="text-align: center;">微信昵称</a-col>
												<a-col :span="2" style="text-align: center;">微信头像</a-col>
												<a-col :span="3" style="text-align: center;">手机号码</a-col>
												<a-col :span="2" style="text-align: center;">等级</a-col>
												<a-col :span="2" style="text-align: center;">平台来源</a-col>
												<a-col :span="2" style="text-align: center;">来源app</a-col>
												<a-col :span="10" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;" v-for="agent in agentlist" :key="agent">
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
												<a-col :span="2" style="text-align: center;">{{agent.nick_name}}</a-col>
												<a-col :span="2" style="text-align: center;"><img :src="agent.UIC_User.avatar_url" height="56" /></a-col>
												<a-col :span="3" style="text-align: center;">{{agent.phone_number}}</a-col>
												<a-col :span="2" style="text-align: center;">{{status[agent.level]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{platform_name[agent.user_from_platform]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{app_name[agent.user_from_app]}}</a-col>
												<a-col :span="10" style="text-align: center;">
													<div>
														<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" @click="toinfo(agent.id)">查看详情</a-button>
														<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" @click="searchlowerlevel(agent)">查询下级</a-button>
														<!-- <a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;">查询绩效</a-button> -->
														<a-upload name="excelfile" :showUploadList="false" :data="{id:agent.id}" :multiple="false" action="/upload/excel"
														 headers="authorization-text" @change="daoru" :beforeUpload="beforeUpload">
															<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" :loading="loading" :disabled="loading">导入订单</a-button>
														</a-upload>
														<a-button size="small" type="danger" ghost style="width: 96px;font-size: 12px;" @click="deleteagent(agent)">删除</a-button>
													</div>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;background-color: #ffe9a0;"
											 v-if="agent.lowerlevel==2" v-for="loweinfo in agent.lowerlevelinfo" :key="loweinfo">
												<a-col :span="2" style="text-align: center;">{{loweinfo.nick_name}}</a-col>
												<a-col :span="2" style="text-align: center;"><img :src="loweinfo.UIC_User.avatar_url" height="56" /></a-col>
												<a-col :span="3" style="text-align: center;">{{loweinfo.phone_number}}</a-col>
												<a-col :span="2" style="text-align: center;">{{status[loweinfo.level]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{platform_name[loweinfo.user_from_platform]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{app_name[loweinfo.user_from_app]}}</a-col>
												<a-col :span="!loweinfo.reviewed?4:10" style="text-align: center;">
													{{loweinfo.reviewed?'已审核':'未审核'}}
												</a-col>
												<a-col :span="6" style="text-align: center;" v-if="!loweinfo.reviewed">
													<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" @click="passloweinfo(loweinfo)">通过</a-button>
													<a-button size="small" type="danger" ghost style="width: 96px;font-size: 12px;" @click="denyloweinfo(loweinfo)">拒绝</a-button>
												</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;background-color: #ffe9a0;"
											 v-if="agent.lowerlevel==1">
												<a-col :span="2" style="text-align: center;">查无下级</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="agentsum"
										 showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="钻石会员" :key="2">
								<div style="padding-bottom: 50px;">
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!agentlist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="agentlist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="2" style="text-align: center;">微信昵称</a-col>
												<a-col :span="2" style="text-align: center;">微信头像</a-col>
												<a-col :span="3" style="text-align: center;">手机号码</a-col>
												<a-col :span="2" style="text-align: center;">等级</a-col>
												<a-col :span="2" style="text-align: center;">平台来源</a-col>
												<a-col :span="2" style="text-align: center;">来源app</a-col>
												<a-col :span="2" style="text-align: center;">上级</a-col>
												<a-col :span="9" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;" v-for="agent in agentlist" :key="agent">
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
												<a-col :span="2" style="text-align: center;">{{agent.nick_name}}</a-col>
												<a-col :span="2" style="text-align: center;"><img :src="agent.UIC_User.avatar_url" height="56" /></a-col>
												<a-col :span="3" style="text-align: center;">{{agent.phone_number}}</a-col>
												<a-col :span="2" style="text-align: center;">{{status[agent.level]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{platform_name[agent.user_from_platform]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{app_name[agent.user_from_app]}}</a-col>
												<a-col :span="2" style="text-align: center;">{{agent.superior_id!==0?agent.superior_id:'无'}}</a-col>
												<a-col :span="9" style="text-align: center;">
													<div>
														<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" @click="toinfo(agent.id)">查看详情</a-button>
														<!-- <a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;">查询绩效</a-button> -->
														<a-upload name="excelfile" :showUploadList="false" :data="{id:agent.id}" :multiple="false" action="/upload/excel"
														 headers="authorization-text" @change="daoru" :beforeUpload="beforeUpload">
															<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" :loading="loading" :disabled="loading">导入订单</a-button>
														</a-upload>
														<a-button size="small" type="danger" ghost style="width: 96px;font-size: 12px;" @click="deleteagent(agent)">删除</a-button>
													</div>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="agentsum"
										 showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
						</a-tabs>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: ['agentlist'],
				openKeys: ['agentmanagement'],
				liststatus: parseInt(this.$route.query.liststatus) || 1,
				searchlist: {
					nick_name: null,
					phone_number: null,
					agency_id: null
				},
				agentlist: [],
				status: {
					'1': '皇冠会员',
					'2': '钻石会员',
				},
				app_name: {},
				platform_name: {
					'1': '微信',
					'2': '支付宝',
					'3': '百度',
				},
				agentsum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				issearch: false,
				userlist: null,
				loading:false

			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
			}
			this.initialize();
		},
		methods: {
			initialize() {
				var self = this;
				this.issearch = true;
				this.agentlist = [];
				this.agentsum = 0;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize,
					liststatus: this.liststatus
				};
				this.$axios.get('/agent/getlist', {
					params: params
				}).then(function(res) {
					self.agentlist = res.data.agentlist;
					self.agentsum = res.data.agentsum;
					var app_temp = {};
					for (var i = 0; i < res.data.appslist.length; i++) {
						app_temp[res.data.appslist[i].id] = res.data.appslist[i].app_name;
					}
					self.app_name = app_temp;
					self.userlist = res.data.userlist;
					self.issearch = false;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'agentlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'agentlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'agentlist',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			toinfo(agent_id) {
				this.$router.push({
					name: 'agentinfo',
					query: {
						agent_id: agent_id
					}
				})
			},
			addagent(user) {
				var params = user
				params.user_id = user.id;
				delete params.id;
				delete params.created_at;
				delete params.updated_at;
				params.reviewed = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否新增代理',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/agent/addnew', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});

			},
			searchlowerlevel(agent) {
				var self = this;
				var params = {
					user_id: agent.user_id
				};
				this.$axios.get('/agent/getlowerlevel', {
					params: params
				}).then(function(res) {
					self.$set(agent, 'lowerlevelinfo', res.data.agentinfo);
					if (res.data.agentinfo.length) {
						self.$set(agent, 'lowerlevel', 2);
					} else {
						self.$set(agent, 'lowerlevel', 1);
					}

				})
			},
			deleteagent(agent) {
				// console.log(agent);
				var params = {
					user_id: agent.user_id
				};
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否删除该代理',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/agent/delete', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});
			},
			passloweinfo(loweinfo) {
				// console.log(loweinfo);
				var params = {
					id: loweinfo.id,
					user_id: loweinfo.user_id
				};
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否通过该代理',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/agent/passlow', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});
			},
			denyloweinfo(loweinfo) {
				// console.log(loweinfo);
				var params = {
					id: loweinfo.id
				};
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否拒绝该代理',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/agent/denylow', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						})
					},
					onCancel() {},
				});
			},
			daoru(info) {
				this.loading = true;
				if (info.file.status === 'done') {
					this.$message.success(`${info.file.name} 文件上传成功,订单已成功导入`);
					this.loading = false;
					this.$router.push({
						name: 'transactionlist',
						query: {
							liststatus: 'to_be_paid'
						}
					})
				} else if (info.file.status === 'error') {
					this.loading = false;
					this.$message.error(`${info.file.name} 文件上传失败`);
				}
			},
			beforeUpload(file) {
				var reg = /^.*\.(?:xls|xlsx)$/i;
				if (!reg.test(file.name)) {
					this.$message.error('请上传excel格式的文件!')
					return false
				} else {
					return true
				}
			},


		},

	};
</script>

<style>

	.agentlist .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.agentlist .card-container {
		overflow: hidden;
	}

	.agentlist .card-container>.ant-tabs-card>.ant-tabs-content {
		min-height: 120px;
		margin-top: -16px;
	}

	.agentlist .card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
		background: #fff;
		padding: 16px;
	}

	.agentlist .card-container>.ant-tabs-card>.ant-tabs-bar {
		border-color: #fff;
	}

	.agentlist .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
		border-color: transparent;
		background: #ebebee;
		width: 90px;
		text-align: center;
	}

	.agentlist .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
		border-color: #fff;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// index.vue?b1cee860